import { useState } from "react";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const ClientAbout = () => {
  const [openAdvisor, setOpenAdvisor] = useState(null);

  const toggleAdvisor = (index) => {
    setOpenAdvisor(openAdvisor === index ? null : index);
  };

  // Added image paths to the advisor data
  const advisors = [
    {
      name: "Hollis D. Ellis, P.E.",
      role: "Civil Engineering & Site Development",
      desc: "Professional background: Civil engineer associated with Providence Partnership LLC, with experience in civil engineering, site development, and project management.",
      image: "/assets/images/about-us/hollis-ellis.png"
    },
    {
      name: "Craig Reed",
      role: "Vice President, Southern Bank Commercial Lending",
      desc: `Craig Reed has extensive experience in the banking industry, with a focus on commercial lending and real estate management. Craig worked as a Vice President of Commercial Lending at Southern Bank and Trust Company from December 2016. Prior to this, they served as an REO Manager at the same company from September 2011 to December 2016. Before joining Southern Bank and Trust Company, Craig was an REO Manager at Bank of the Commonwealth from September 2009 to September 2011. Craig also held the position of Regional Manager at Bank of the Commonwealth from August 2006 to September 2009. Earlier in their career, Craig worked as a VP of Commercial Lending at Bank of Hampton Roads from August 2002 to August 2006 and as a Branch Manager at Wachovia from June 2000 to August 2002.

Craig Reed attended The University of Virginia's College at Wise from 1996-1997, but did not complete a degree or have a declared field of study during that time. Craig later attended Randolph-Macon College from 1997-2000, where they earned a Bachelor of Science (BS) degree in Economics.`,
      image: "/assets/images/about-us/craig-reed.png"
    },
    {
      name: "William Blanks, Sr.",
      role: "Commander, U.S. Navy (Retired)",
      desc: `Advisory Focus: Leadership, Strategic Planning & Community Engagement 
      
      His reported experience mentoring students is relevant to JGF's family-support and educational mission. 
      
      Recommendation: Request his preferred headshot, preferably a high-resolution civilian professional portrait or an authorized military portrait. We can then format it with the same circular framing and teal branding as the JGF Leadership Team.`,
      image: "/assets/images/about-us/dennis-woodbury.png"
    },
    {
      name: "Nazim Ghori",
      role: "ICommune Tech Developer Software Engineering & Platform Technology",
      desc: "Co-Founder and CEO of ICommune Tech and he specializes in PHP/Laravel, AWS, and DevOps.",
      image: "/assets/images/about-us/nazim-ghori.png"
    },
    {
      name: "Gregory Pomeroy",
      role: "Systems Automation & Integration Consultant",
      desc: "His work with Pomeroy Agency, Make.com, Zapier, QuickBooks integrations, and business process automation. ",
      image: "/assets/images/about-us/dennis-woodbury.png"
    }
  ];

  return (
    <>
      <ClientHeader />
      <main className="overflow-hidden">

        {/* --- EDITORIAL HERO SECTION --- */}
        <section className="homepad-about py-5" style={{ backgroundColor: "#f4f7f6" }}>
          <div className="container py-lg-5">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-5 mb-lg-0 pe-lg-5">
                <h6 className="text-success font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "2px" }}>
                  Our People
                </h6>
                <h1 className="font-weight-bold montserrat text-primary mb-4" style={{ fontSize: "3.5rem", lineHeight: "1.1" }}>
                  The Minds Behind <br /> <span className="text-success">The Mission.</span>
                </h1>
                <p className="font-size-18 text-muted line-hight-3 mb-4">
                  Committed to the early identification, intervention, and family support for young children with developmental needs. Our team guides our mission, strategy, and community impact to create brighter futures.
                </p>
                <div className="d-flex align-items-center mt-5">
                  <div className="bg-primary rounded-circle p-3 me-3">
                    <img src="/assets/images/logo.png" alt="Icon" height="30" width="30" />
                  </div>
                  <div>
                    <h5 className="mb-0 font-weight-bold">The Just Generation</h5>
                    <span className="text-muted font-size-14">Foundation</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <img
                  src="/assets/images/about-img.jpg"
                  alt="Team"
                  className="w-100 rounded-4 shadow-lg"
                  style={{ objectFit: "cover", height: "500px" }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* --- INTERACTIVE ADVISORY ACCORDION (WITH IMAGES) --- */}
        <section className="py-5" style={{ backgroundColor: "#083B5C" }}>
          <div className="container py-lg-5">
            <div className="row justify-content-center text-center mb-5 pb-4">
              <div className="col-lg-8">
                <h2 className="font-weight-bold montserrat text-white font-size-46 mb-3">Advisory & Technical Team</h2>
                <p className="text-white opacity-75 font-size-18 mb-0">
                  Experts in engineering, finance, military leadership, and technology guiding our strategic growth.
                </p>
              </div>
            </div>

            {/* TOP ROW: 2 Cards (Craig & William - Wide for long text) */}
            <div className="row g-4 justify-content-center mb-4">

              {/* Card 1: Craig */}
              <div className="col-md-12 col-lg-6">
                <div
                  className="card h-100 border-0 rounded-4 shadow-sm p-4 text-center"
                  style={{ backgroundColor: "#ffffff", transition: "transform 0.3s ease, box-shadow 0.3s ease" }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.2)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 0.125rem 0.25rem rgba(0,0,0,0.075)"; }}
                >
                  <div className="mb-4 d-flex justify-content-center">
                    <img src="/assets/images/about-us/craig-reed.png" alt="Craig Reed" className="rounded-circle border border-3 border-success shadow-sm" style={{ width: "120px", height: "120px", objectFit: "cover", objectPosition: "top" }} />
                  </div>
                  <h4 className="font-weight-bold font-size-22 mb-1 text-primary">Craig Reed</h4>
                  <p className="text-success font-weight-semibold font-size-14 text-uppercase mb-3">Vice President, Southern Bank Commercial Lending</p>
                  <hr className="mx-auto" style={{ width: "40px", opacity: 0.2 }} />
                  <p className="font-size-15 text-muted mb-0 text-wrap text-start" style={{ lineHeight: "1.6", whiteSpace: "pre-line" }}>
                    Craig Reed has extensive experience in the banking industry, with a focus on commercial lending and real estate management. Craig worked as a Vice President of Commercial Lending at Southern Bank and Trust Company from December 2016. Prior to this, they served as an REO Manager at the same company from September 2011 to December 2016. Before joining Southern Bank and Trust Company, Craig was an REO Manager at Bank of the Commonwealth from September 2009 to September 2011. Craig also held the position of Regional Manager at Bank of the Commonwealth from August 2006 to September 2009. Earlier in their career, Craig worked as a VP of Commercial Lending at Bank of Hampton Roads from August 2002 to August 2006 and as a Branch Manager at Wachovia from June 2000 to August 2002.
                  </p>
                  <br />
                  <p className="font-size-15 text-muted mb-0 text-wrap text-start" style={{ lineHeight: "1.6", whiteSpace: "pre-line" }}>
                    Craig Reed attended The University of Virginia's College at Wise from 1996-1997, but did not complete a degree or have a declared field of study during that time. Craig later attended Randolph-Macon College from 1997-2000, where they earned a Bachelor of Science (BS) degree in Economics.
                  </p>
                </div>
              </div>

              {/* Card 2: William */}
              <div className="col-md-12 col-lg-6">
                <div
                  className="card h-100 border-0 rounded-4 shadow-sm p-4 text-center"
                  style={{ backgroundColor: "#ffffff", transition: "transform 0.3s ease, box-shadow 0.3s ease" }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.2)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 0.125rem 0.25rem rgba(0,0,0,0.075)"; }}
                >
                  <div className="mb-4 d-flex justify-content-center">
                    <img src="/assets/images/about-us/dennis-woodbury.png" alt="William Blanks" className="rounded-circle border border-3 border-success shadow-sm" style={{ width: "120px", height: "120px", objectFit: "cover", objectPosition: "top" }} />
                  </div>
                  <h4 className="font-weight-bold font-size-22 mb-1 text-primary">William Blanks, Sr.</h4>
                  <p className="text-success font-weight-semibold font-size-14 text-uppercase mb-3">Commander, U.S. Navy (Retired)</p>
                  <hr className="mx-auto" style={{ width: "40px", opacity: 0.2 }} />
                  <p className="font-size-15 text-muted mb-0 text-wrap text-start" style={{ lineHeight: "1.6", whiteSpace: "pre-line" }}>
                    Advisory Focus: Leadership, Strategic Planning & Community Engagement
                  </p>
                  <br />

                  <p className="font-size-15 text-muted mb-0 text-wrap text-start" style={{ lineHeight: "1.6", whiteSpace: "pre-line" }}>
                    His reported experience mentoring students is relevant to JGF's family-support and educational mission.
                  </p>
                  <br />

                  <p className="font-size-15 text-muted mb-0 text-wrap text-start" style={{ lineHeight: "1.6", whiteSpace: "pre-line" }}>
                    Recommendation: Request his preferred headshot, preferably a high-resolution civilian professional portrait or an authorized military portrait. We can then format it with the same circular framing and teal branding as the JGF Leadership Team.
                  </p>
                </div>
              </div>

            </div>

            {/* BOTTOM ROW: 3 Cards (Hollis, Nazim, Gregory) */}
            <div className="row g-4 justify-content-center">

              {/* Card 3: Hollis */}
              <div className="col-md-6 col-lg-4">
                <div
                  className="card h-100 border-0 rounded-4 shadow-sm p-4 text-center"
                  style={{ backgroundColor: "#ffffff", transition: "transform 0.3s ease, box-shadow 0.3s ease" }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.2)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 0.125rem 0.25rem rgba(0,0,0,0.075)"; }}
                >
                  <div className="mb-4 d-flex justify-content-center">
                    <img src="/assets/images/about-us/hollis-ellis.png" alt="Hollis D. Ellis" className="rounded-circle border border-3 border-success shadow-sm" style={{ width: "120px", height: "120px", objectFit: "cover", objectPosition: "top" }} />
                  </div>
                  <h4 className="font-weight-bold font-size-22 mb-1 text-primary">Hollis D. Ellis, P.E.</h4>
                  <p className="text-success font-weight-semibold font-size-14 text-uppercase mb-3">Civil Engineering & Site Development</p>
                  <hr className="mx-auto" style={{ width: "40px", opacity: 0.2 }} />
                  <p className="font-size-15 text-muted mb-0 text-wrap text-start" style={{ lineHeight: "1.6" }}>
                    Professional background: Civil engineer associated with Providence Partnership LLC, with experience in civil engineering, site development, and project management.
                  </p>
                </div>
              </div>

              {/* Card 4: Nazim */}
              <div className="col-md-6 col-lg-4">
                <div
                  className="card h-100 border-0 rounded-4 shadow-sm p-4 text-center"
                  style={{ backgroundColor: "#ffffff", transition: "transform 0.3s ease, box-shadow 0.3s ease" }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.2)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 0.125rem 0.25rem rgba(0,0,0,0.075)"; }}
                >
                  <div className="mb-4 d-flex justify-content-center">
                    <img src="/assets/images/about-us/nazim-ghori.png" alt="Nazim Ghori" className="rounded-circle border border-3 border-success shadow-sm" style={{ width: "120px", height: "120px", objectFit: "cover", objectPosition: "top" }} />
                  </div>
                  <h4 className="font-weight-bold font-size-22 mb-1 text-primary">Nazim Ghori</h4>
                  <p className="text-success font-weight-semibold font-size-14 text-uppercase mb-3">ICommune Tech Developer Software Engineering & Platform Technology</p>
                  <hr className="mx-auto" style={{ width: "40px", opacity: 0.2 }} />
                  <p className="font-size-15 text-muted mb-0 text-wrap text-start" style={{ lineHeight: "1.6" }}>
                    Co-Founder and CEO of ICommune Tech and he specializes in PHP/Laravel, AWS, and DevOps.
                  </p>
                </div>
              </div>

              {/* Card 5: Gregory */}
              <div className="col-md-6 col-lg-4">
                <div
                  className="card h-100 border-0 rounded-4 shadow-sm p-4 text-center"
                  style={{ backgroundColor: "#ffffff", transition: "transform 0.3s ease, box-shadow 0.3s ease" }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.2)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 0.125rem 0.25rem rgba(0,0,0,0.075)"; }}
                >
                  <div className="mb-4 d-flex justify-content-center">
                    <img src="/assets/images/about-us/dennis-woodbury.png" alt="Gregory Pomeroy" className="rounded-circle border border-3 border-success shadow-sm" style={{ width: "120px", height: "120px", objectFit: "cover", objectPosition: "top" }} />
                  </div>
                  <h4 className="font-weight-bold font-size-22 mb-1 text-primary">Gregory Pomeroy</h4>
                  <p className="text-success font-weight-semibold font-size-14 text-uppercase mb-3">Systems Automation & Integration Consultant</p>
                  <hr className="mx-auto" style={{ width: "40px", opacity: 0.2 }} />
                  <p className="font-size-15 text-muted mb-0 text-wrap text-start" style={{ lineHeight: "1.6" }}>
                    His work with Pomeroy Agency, Make.com, Zapier, QuickBooks integrations, and business process automation.
                  </p>
                </div>
              </div>

            </div>

          </div>
        </section>

        {/* --- STAGGERED LEADERSHIP SECTION --- */}
        <section className="py-5 my-5">
          <div className="container py-lg-4">
            <div className="row justify-content-center text-center mb-5 pb-4">
              <div className="col-lg-8">
                <h2 className="font-weight-bold montserrat text-primary font-size-46 mb-3">Leadership Team</h2>
                <div className="mx-auto bg-success" style={{ height: "3px", width: "60px" }}></div>
              </div>
            </div>

            {/* Dennis */}
            <div className="row align-items-center mb-5 pb-lg-4">
              <div className="col-lg-5 mb-4 mb-lg-0">
                <div className="position-relative">
                  <div className="position-absolute bg-success rounded-4 w-100 h-100" style={{ top: "20px", left: "-20px", zIndex: 0, opacity: 0.1 }}></div>
                  {/* Changed to contain and added a light background */}
                  <img
                    src="/assets/images/about-us/dennis-woodbury.png"
                    alt="Dennis"
                    className="w-100 rounded-4 shadow position-relative"
                    style={{ zIndex: 1, height: "400px", objectFit: "contain", backgroundColor: "#f8f9fa" }}
                  />
                </div>
              </div>
              <div className="col-lg-7 ps-lg-5">
                <h3 className="font-weight-bold font-size-32 mb-1 text-primary">Dennis T. Woodbury</h3>
                <p className="text-success font-weight-semibold font-size-18 mb-4 text-uppercase">Founder & Chairman</p>
                <p className="font-size-16 text-muted line-hight-3">
                  Dennis T. Woodbury provides the vision and strategic leadership guiding The Just Generation Foundation. Drawing on decades of entrepreneurial and organizational leadership, he is advancing JGF's mission to strengthen early identification, intervention, and inclusive educational opportunities for children with developmental needs. His leadership focuses on building sustainable programs, strategic partnerships, and community resources that empower children and families.
                </p>
              </div>
            </div>

            {/* Mrs. Boyd */}
            <div className="row align-items-center mb-5 pb-lg-4 flex-lg-row-reverse">
              <div className="col-lg-5 mb-4 mb-lg-0">
                <div className="position-relative">
                  <div className="position-absolute bg-primary rounded-4 w-100 h-100" style={{ top: "20px", right: "-20px", zIndex: 0, opacity: 0.1 }}></div>
                  {/* Changed to contain and added a light background */}
                  <img
                    src="/assets/images/about-us/dennis-woodbury.png"
                    alt="Mrs. Boyd"
                    className="w-100 rounded-4 shadow position-relative"
                    style={{ zIndex: 1, height: "400px", objectFit: "contain", backgroundColor: "#f8f9fa" }}
                  />
                </div>
              </div>
              <div className="col-lg-7 pe-lg-5 text-lg-end">
                <h3 className="font-weight-bold font-size-32 mb-1 text-primary">Mrs. Boyd</h3>
                <p className="text-success font-weight-semibold font-size-18 mb-4 text-uppercase">Vice-Chairman & Director</p>
                <p className="font-size-16 text-muted line-hight-3">
                  As Vice-Chairman and Director, Mrs. Boyd supports JGF's organizational governance, strategic planning, and commitment to community service. Her leadership role emphasizes accountability, collaboration, and responsible stewardship of the Foundation's mission to expand access to early childhood developmental resources and family support.
                </p>
              </div>
            </div>

            {/* Babette & Juliana */}
            <div className="row g-5 mt-4">
              <div className="col-md-6">
                <img
                  src="/assets/images/about-us/dennis-woodbury.png"
                  alt="Babette"
                  className="w-100 rounded-4 mb-4"
                  style={{ height: "350px", objectFit: "contain", backgroundColor: "#f8f9fa" }}
                />
                <h3 className="font-weight-bold font-size-28 mb-1 text-primary">Babette L. Woodbury</h3>
                <p className="text-success font-weight-semibold font-size-16 mb-3 text-uppercase">Secretary & Treasurer</p>
                <p className="font-size-15 text-muted">
                  Babbette L. Woodbury brings years of experience in early childhood education and childcare operations to JGF's leadership. As Secretary and Treasurer, she supports organizational governance, financial accountability, and administrative oversight. Her commitment to children and families reinforces the Foundation's emphasis on early intervention, inclusive education, and access to essential developmental resources.
                </p>
              </div>
              <div className="col-md-6">
                <img
                  src="/assets/images/about-us/dennis-woodbury.png"
                  alt="Juliana"
                  className="w-100 rounded-4 mb-4"
                  style={{ height: "350px", objectFit: "contain", backgroundColor: "#f8f9fa" }}
                />
                <h3 className="font-weight-bold font-size-28 mb-1 text-primary">Juliana Armstrong</h3>
                <p className="text-success font-weight-semibold font-size-16 mb-3 text-uppercase">Director of Development & Community Engagement</p>
                <p className="font-size-15 text-muted">
                  Juliana Armstrong leads JGF's fundraising development, donor engagement, and community partnership initiatives. Drawing on her campaign management and development experience, she works to strengthen relationships with supporters, businesses, and community organizations. Her efforts help mobilize the financial resources and strategic partnerships needed to advance JGF's programs, capital campaign, and long-term sustainability.
                </p>
              </div>
            </div>
          </div>
        </section>



      </main>
      <ClientFooter />
    </>
  );
}

export default ClientAbout;